module.exports = __webpack_public_path__ + "img/balsa.7572467c.svg";